let ctx;
let master;
let dry;
let convolver;
let delay;
let chordTimer;
let pluckTimer;
let chordIdx = 0;
let running = false;

const CHORDS = [
  { bass: 87.31, notes: [220.0, 261.63, 329.63, 523.25] },
  { bass: 98.0, notes: [246.94, 293.66, 392.0, 587.33] },
  { bass: 110.0, notes: [196.0, 261.63, 329.63, 523.25] },
  { bass: 82.41, notes: [246.94, 293.66, 392.0, 493.88] },
];

const PLUCKS = [220.0, 261.63, 293.66, 329.63, 392.0, 440.0, 523.25, 587.33, 659.26];

function makeImpulse(seconds, decay) {
  const rate = ctx.sampleRate;
  const len = Math.floor(rate * seconds);
  const buffer = ctx.createBuffer(2, len, rate);
  for (let ch = 0; ch < 2; ch++) {
    const data = buffer.getChannelData(ch);
    for (let i = 0; i < len; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, decay);
    }
  }
  return buffer;
}

function buildGraph() {
  ctx = new (window.AudioContext || window.webkitAudioContext)();
  master = ctx.createGain();
  master.gain.value = 0;

  const comp = ctx.createDynamicsCompressor();
  comp.threshold.value = -24;
  comp.ratio.value = 4;
  master.connect(comp);
  comp.connect(ctx.destination);

  dry = ctx.createGain();
  dry.gain.value = 0.55;
  dry.connect(master);

  convolver = ctx.createConvolver();
  convolver.buffer = makeImpulse(2.8, 2.4);
  const wet = ctx.createGain();
  wet.gain.value = 0.5;
  convolver.connect(wet);
  wet.connect(master);

  delay = ctx.createDelay(2);
  delay.delayTime.value = 0.42;
  const feedback = ctx.createGain();
  feedback.gain.value = 0.3;
  delay.connect(feedback);
  feedback.connect(delay);
  delay.connect(convolver);
}

function tone(freq, { type = "sine", gain, attack, release, pan = 0, dest }) {
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  osc.type = type;
  osc.frequency.value = freq;

  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t + attack + release);

  const p = ctx.createStereoPanner();
  p.pan.value = pan;

  osc.connect(g);
  g.connect(p);
  p.connect(dest === "fx" ? delay : dry);
  p.connect(convolver);

  osc.start(t);
  osc.stop(t + attack + release + 0.2);
}

function playChord() {
  const chord = CHORDS[chordIdx % CHORDS.length];
  chordIdx += 1;
  tone(chord.bass, { type: "sine", gain: 0.07, attack: 1.8, release: 6.6 });
  chord.notes.forEach((f, i) => {
    tone(f, { type: "triangle", gain: 0.028, attack: 3, release: 6, pan: (i % 2 ? 1 : -1) * 0.35 });
    tone(f * 1.003, { type: "triangle", gain: 0.02, attack: 3.4, release: 6, pan: (i % 2 ? -1 : 1) * 0.3 });
  });
}

function pluckLoop() {
  if (Math.random() < 0.78) {
    const f = PLUCKS[Math.floor(Math.random() * PLUCKS.length)];
    tone(f, {
      type: "sine",
      gain: 0.05 + Math.random() * 0.04,
      attack: 0.012,
      release: 2.4,
      pan: Math.random() * 1.2 - 0.6,
      dest: "fx",
    });
  }
  pluckTimer = setTimeout(pluckLoop, 520 + Math.random() * 420);
}

export function startAmbience() {
  if (!ctx) buildGraph();
  if (ctx.state === "suspended") ctx.resume();
  running = true;
  const t = ctx.currentTime;
  master.gain.cancelScheduledValues(t);
  master.gain.setValueAtTime(Math.max(master.gain.value, 0.0001), t);
  master.gain.exponentialRampToValueAtTime(0.9, t + 2);
  playChord();
  chordTimer = setInterval(playChord, 7000);
  pluckLoop();
}

export function stopAmbience() {
  if (!ctx || !running) return;
  running = false;
  clearTimeout(pluckTimer);
  clearInterval(chordTimer);
  const t = ctx.currentTime;
  master.gain.cancelScheduledValues(t);
  master.gain.setValueAtTime(Math.max(master.gain.value, 0.0001), t);
  master.gain.exponentialRampToValueAtTime(0.0001, t + 1.2);
}
